{
  "2d": "2D",
  "3d": "3D",
  "tilt": "Tilt the map to see the terrain in 3D",
  "flatten": "Back to a flat 2D map"
}
